// Sentinel for the "all objects" entry in the group select. A code created
// with it carries NO group and NO location, which redemption reads as "applies
// to every object of this tenant" — so one promotion covers all stations /
// apartments / venues instead of one code per object. Distinct from '' so the
// disabled placeholder still means "nothing picked yet".
//
// Step 1 of the CEO's staged plan (2026-07-31): this spans every service the
// tenant runs. Narrowing it to one service needs a `use_case` column on
// voucher — the lead-dev follow-up (docs/plans/promo-code-scope.md).
export const ALL_OBJECTS_SCOPE = '__all_objects__';

/**
 * What the "Applies to" select starts on (#3052, PO 2026-10-30): every new
 * code — promo (single or campaign) and goodwill alike — applies at every
 * station; restricting it to one object is a deliberate pick. One default for
 * every create form, so they cannot drift apart. Existing codes are not touched.
 */
export const defaultCodeScope = (): string => ALL_OBJECTS_SCOPE;
